// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"74e43ca3","455":"2ab26f14","867":"82d332bc","977":"36de6f12"}[chunkId] + ".chunk.js";
};